<mat-dialog-content class="dialog-content">
  <mg-welcome-district-school-select (done)="close()"></mg-welcome-district-school-select>
</mat-dialog-content>
